import { prop } from 'ramda';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useUserSelector } from 'js/store/hooks';
import { updatePopupAction } from 'js/components/common/PopupManager/store/actions';
import { sendCloseNotification } from '../server';

export const useClosingSync = () => {
    const storedWindowSessionId = useUserSelector(prop('windowSessionId'));
    const dispatch = useDispatch();

    return useCallback(
        (token, { windowSessionId } = {}) => {
            dispatch(updatePopupAction({ id: token, isSyncClosed: true }));

            return sendCloseNotification({
                actionId: token,
                windowSessionId: windowSessionId ?? storedWindowSessionId
            });
        },
        [dispatch, storedWindowSessionId]
    );
};
